import styled from "styled-components";

import {
  BREAKPOINT,
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  hoverStyles,
} from "../../constants/Styles";

export const Card = styled.div`
  display: flex;
  width: 500px;
  padding: 3.5rem 4rem 2rem;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;
  gap: 2rem;

  @media (max-width: ${BREAKPOINT}) {
    width: 350px;
    padding: 3.5rem 2rem 2rem;
  }

  ${CARD_BACKGROUND};
  color: ${COLORS.secondary};
`;

export const Header = styled.h2`
  font-family: ${FONTS.spaceGrotesk};
  font-weight: ${FONT_WEIGHT.weight500};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  > button {
    width: 100%;
  }
`;

export const SubmitContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const UnimportantText = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export const PrivacyLink = styled(UnimportantText)`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  font-weight: ${FONT_WEIGHT.weight500};
  text-decoration: underline;
  cursor: pointer;
  ${hoverStyles};
`;

export const ResultInfo = styled.div`
  text-align: center;
  min-height: 3rem;
  padding: 2rem 0 0 0;
`;
